import { useEffect, useState } from "react";
import SectionHeroBCR from "components/HomeSections/SectionHeroBCR";
import SectionWhyChooseUs from "components/HomeSections/SectionWhyChooseUs";
import SectionOurProducts from "components/HomeSections/SectionOurProducts";
import SectionCategoriesIcons from "components/HomeSections/SectionCategoriesIcons";
import SectionProjectsPreview from "components/HomeSections/SectionProjectsPreview";
import SectionClientsLogos from "components/HomeSections/SectionClientsLogos";
import SectionAboutPreview from "components/HomeSections/SectionAboutPreview";
import SectionContactPreview from "components/HomeSections/SectionContactPreview";
import { API_BASE_URL } from "data/axiosClient";

const fetchCategories = async () => {
  const response = await fetch(
    `${API_BASE_URL}/products/home-categories/`
  );
  const data = await response.json();
  return data.data.map((item: any) => ({
    id: item.id.toString(),
    name: item.name,
    href: `/categories/${item.id}`,
  }));
};

function PageHome() {
  const [categories, setCategories] = useState<{ id: string; name: string; href: string }[]>([]);

  useEffect(() => {
    fetchCategories()
      .then(setCategories)
      .catch((err) => console.error("Error fetching categories:", err));
  }, []);

  return (
    <div className="nc-PageHome">
      <SectionHeroBCR />
      <SectionWhyChooseUs />
      <SectionOurProducts />
      <SectionCategoriesIcons items={categories} />
      <SectionProjectsPreview />
      <SectionClientsLogos />
      <SectionAboutPreview />
      <SectionContactPreview />
    </div>
  );
}

export default PageHome;
